module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/schedule-3-839c1ad953d387eeb5dc3052b23c3d8a.jpg";